/* eslint-disable max-len */
import { SvgProps } from './types'

export const CalculatorChartIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="57"
      height="64"
      viewBox="0 0 57 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <g clipPath="url(#clip0_1020_2479)">
        <path d="M3.87619 32.1292H19.3624C20.3952 32.1292 21.2386 32.971 21.2386 34.0157V60.4334C21.2386 61.4719 20.4014 62.3199 19.3624 62.3199H3.87619C2.84337 62.3199 2 61.478 2 60.4334V34.0157C2 32.9772 2.83726 32.1292 3.87619 32.1292Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.7612 35.6689H5.52626V41.5191H17.7612V35.6689Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.83252 48.1924H5.56905" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.2112 48.1924H14.2105" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.83252 53.5142H5.56905" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.2112 53.5142H14.2105" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8.83252 58.8296H5.56905" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.2112 58.8296H14.2105" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M10.7882 24.958V8.5568C10.7882 7.76409 11.4237 7.125 12.2121 7.125H48.6787C49.4671 7.125 50.1026 7.76409 50.1026 8.5568V60.8821C50.1026 61.6748 49.4671 62.3139 48.6787 62.3139H25.761" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18.7757 2H54.1301C54.9184 2 55.554 2.63909 55.554 3.4318V54.4543" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M30.4423 30.384C35.7853 30.384 40.1167 26.0288 40.1167 20.6564C40.1167 15.2839 35.7853 10.9287 30.4423 10.9287C25.0994 10.9287 20.768 15.2839 20.768 20.6564C20.768 26.0288 25.0994 30.384 30.4423 30.384Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M28.7862 22.4629L24.1049 27.5694" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M30.4423 10.9287V20.6564L28.7862 22.463" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M30.4423 20.6562H20.7741" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M44.7124 36.271H30.4423" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M44.7124 41.562H30.4423" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M44.7124 47.2217H30.4423V55.8862H44.7124V47.2217Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      </g>
      <defs>
        <clipPath id="clip0_1020_2479">
          <rect width="57" height="64" fill="white" transform="translate(0 0.00390625)"/>
        </clipPath>
      </defs>
    </svg>
  )
}
